/*
 * OZONE - Product title publisher style
 *
 * Cosmetic-only enhancement: in every product title across the storefront
 * (featured products, collection pages, product page, cart, search, drawers...)
 * everything that comes after the first "/" (the slash included) is wrapped in
 * a <span class="ozone-pub-suffix"> so it can be shown bold + uppercase via CSS.
 *
 * It NEVER changes the product name nor the SEO: the rendered text content of
 * each title stays exactly the same, we only add an inline span for styling.
 * The styling itself lives in the CSS rule .ozone-pub-suffix (see settings.liquid)
 * and this whole script is loaded only when the OZONE setting is enabled.
 */
(function () {
  'use strict';

  var TITLE_SELECTORS = [
    '.product-card__title',
    '.product__title',
    '.cart-item__title',
    '.card-product-small-title',
  ];
  var SELECTOR = TITLE_SELECTORS.join(',');
  var SUFFIX_CLASS = 'ozone-pub-suffix';
  var DONE_FLAG = 'ozonePub';

  // Text that does NOT belong to the product name and must be ignored:
  // inline <style>/<script> blocks and badge labels (e.g. "Esaurito", "-20%")
  // that some templates render inside the same title element.
  function isIgnored(textNode, root) {
    var el = textNode.parentNode;
    while (el && el !== root) {
      var tag = el.nodeName;
      if (tag === 'STYLE' || tag === 'SCRIPT') return true;
      var cl = el.classList;
      if (
        cl &&
        (cl.contains('product-card__badges') ||
          cl.contains('product-card__badge') ||
          cl.contains('product-badges') ||
          cl.contains('cart-item__discount') ||
          cl.contains('visually-hidden'))
      ) {
        return true;
      }
      el = el.parentNode;
    }
    return false;
  }

  function wrapSuffix(titleEl) {
    if (!titleEl || titleEl.dataset[DONE_FLAG] === '1') return;

    // Walk the title's text nodes, skipping style/script/badge content.
    var walker = document.createTreeWalker(titleEl, NodeFilter.SHOW_TEXT, {
      acceptNode: function (textNode) {
        if (isIgnored(textNode, titleEl)) return NodeFilter.FILTER_REJECT;
        return textNode.nodeValue.indexOf('/') !== -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      },
    });

    // First eligible text node that actually contains a "/".
    var slashNode = walker.nextNode();
    if (!slashNode) {
      titleEl.dataset[DONE_FLAG] = '1';
      return;
    }

    var slashPos = slashNode.nodeValue.indexOf('/');
    var before = slashNode.nodeValue.slice(0, slashPos);
    var suffix = slashNode.nodeValue.slice(slashPos);

    var span = document.createElement('span');
    span.className = SUFFIX_CLASS;
    span.textContent = suffix;

    slashNode.nodeValue = before;
    if (slashNode.parentNode) {
      slashNode.parentNode.insertBefore(span, slashNode.nextSibling);
    }

    titleEl.dataset[DONE_FLAG] = '1';
  }

  function process(root) {
    if (!root || !root.querySelectorAll) return;
    // The root itself might be a title (e.g. injected directly).
    if (root.matches && root.matches(SELECTOR)) wrapSuffix(root);
    var titles = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < titles.length; i++) wrapSuffix(titles[i]);
  }

  var scheduled = false;
  var pending = [];
  function flush() {
    scheduled = false;
    var nodes = pending;
    pending = [];
    nodes.forEach(process);
  }
  function schedule(root) {
    pending.push(root);
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(flush);
  }

  function init() {
    process(document);

    if (!('MutationObserver' in window)) return;

    // Re-process dynamically rendered content: cart drawer/cart updates,
    // quick add, predictive search, AJAX section rendering, infinite scroll...
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) schedule(added[j]);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
